import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Link, useLocation } from 'react-router-dom';
import { isDev, useIsPrivilegedUser } from '@/lib/utils';

const Header = () => {
  const isPrivilegedUser = useIsPrivilegedUser();
  const [jwt, setJwt] = useState('');
  const location = useLocation();

  useEffect(() => {
    if (isDev()) {
      const storedJwt = Cookies.get('stytch_session_jwt') || '';
      if (storedJwt) {
        setJwt(storedJwt);
      }
    }
  }, []);

  const copyJwt = () => {
    navigator.clipboard.writeText(jwt);
    alert('JWT copied to clipboard!');
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'font-bold' : '';
  };

  return (
    <header className="sticky top-0 flex items-center justify-between h-16 px-4 border-b shrink-0 md:px-6 z-50 bg-white">
      <nav className="flex items-center flex-1 text-base font-medium">
        <Link to="/">
          <img src="/ryze.png" className="w-[90px] h-[30px] mr-4" alt="Ryze" />
        </Link>
        <div className="flex items-center">
          <a href={`/`} className={`block px-3 py-2 ${isActive(`/`)}`}>
            Inbox
          </a>
          <div className="w-px h-4 bg-gray-300 mx-2"></div>
          <a href={`/projects`} className={`block px-3 py-2 ${isActive(`/projects`)}`}>
            Projects
          </a>
        </div>
      </nav>
      <div className="flex items-center">
        {/* TODO: Implement search
        <form className="mr-2 sm:flex-initial">
          <div className="relative">
            <SearchIcon className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              type="search"
              placeholder="Search claims..."
              className="pl-8 text-md sm:w-[300px] md:w-[200px] lg:w-[300px]"
            />
          </div>
        </form>
        */}
        {import.meta.env.VITE_ENV === 'development' && jwt && (
          <button
            onClick={copyJwt}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Copy JWT
          </button>
        )}
      </div>
    </header>
  );
};

export { Header };
